<div class="profile-selector-ui">
  <div class="profile-selector-ui-wrapper">
    <div class="profile-selector-ui__header">
      <div
        id="profile-selector-closeIcon"
        class="profile-selector-ui-close-icon-box"
        *ngIf="!fromStandAlonePage"
      >
        <span>&nbsp;</span>
        <button
          role="button"
          type="button"
          aria-label="Close"
          (click)="onClose()"
        ></button>
      </div>
      <idp-profile-selector-header
        [profileHeaderContent]="profileDetails.pageHeader"
      ></idp-profile-selector-header>
    </div>
    <div class="profile-selector-ui__personal-selector">
      <idp-personal-profile-selector
        *ngIf="profileDetails && profileDetails.personalProfile"
        [pageData]="profileDetails.personalProfile"
        [personalStateSelected]="personalStateSelected"
        (personalProfileSelected)="personalProfileSelected($event)"
      ></idp-personal-profile-selector>
    </div>
    <div class="profile-selector-ui__divider"></div>
    <div class="profile-selector-ui__business-selector">
      <idp-business-profile-selector
        [pageData]="profileDetails.businessProfile"
        [businessStateSelected]="businessStateSelected"
        (emitCompanyTitle)="businessProfileSelected($event)"
      ></idp-business-profile-selector>
    </div>
    <div *ngIf="displayTermsOfUse">
      <p
        [innerHTML]="profileDetails?.pageFooter?.footerSubText"
        class="profile-selector-ui__footerSubText"
      ></p>
    </div>
    <div *ngIf="!displayTermsOfUse">
      <p
        [innerHTML]="profileDetails?.pageFooter?.footerSubTextWithoutToU"
        class="profile-selector-ui__footerSubText"
      ></p>
    </div>
  </div>
  <div class="profile-selector-ui__footer">
    <idp-button
      *ngIf="!fromStandAlonePage"
      [ariaLabel]="'Log Out'"
      [type]="'link'"
      [label]="'Log Out'"
      [size]="'full-width'"
      (notify)="emitLogout()"
    ></idp-button>
  </div>
</div>
